import mutations from 'shared/helpers/vuex/mutations'

export default {
    ...mutations
}


// WEBPACK FOOTER //
// ./src/enterprise/vuex/mutations.js